import React from "react";
import style from "./index.module.scss";

interface EmptyProps {
    tip: string;
}

export default function Empty({ tip }: EmptyProps) {
    return (
        <div className={style.root}>
            <img src={require("./img/bg.png")} />
            <div className={style.tip}>{tip}</div>
        </div>
    );
}
